import { render, staticRenderFns } from "./assurance-groupes.html?vue&type=template&id=33141542&scoped=true&external"
import script from "./assurance-groupes.js?vue&type=script&lang=js&external"
export * from "./assurance-groupes.js?vue&type=script&lang=js&external"
import style0 from "./assurance-groupes.scss?vue&type=style&index=0&id=33141542&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33141542",
  null
  
)

export default component.exports